var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3008 3.12627V7.79493C2.56643 13.4012 7.13133 14.5999 8.04333 14.7824C8.08521 14.7905 8.12646 14.7949 8.16958 14.7949C8.21271 14.7949 8.25458 14.7899 8.29584 14.7824C9.20772 14.5999 13.7726 13.4017 14.0384 7.79493V3.12627C14.0384 2.83189 13.8365 2.57439 13.5502 2.50376L8.32212 1.22376C8.22274 1.20001 8.11712 1.20001 8.01837 1.22376L2.7889 2.50376C2.50265 2.57439 2.30078 2.83001 2.30078 3.12627H2.3008ZM3.5808 3.62877L8.1696 2.50565L12.7584 3.62877V7.75064C12.5409 12.1744 9.13773 13.2769 8.1696 13.5012C7.20148 13.2774 3.79707 12.1749 3.5808 7.75064V3.62877Z",
    fill: "#F86557"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0502 9.7168C7.1752 9.8418 7.33832 9.90429 7.50271 9.90429C7.66771 9.90429 7.83083 9.84179 7.95522 9.7168L10.8064 6.8656C11.0558 6.61623 11.0558 6.21123 10.8064 5.95997C10.557 5.7106 10.1502 5.7106 9.90079 5.95997L7.50266 8.35811L6.48328 7.33873C6.23391 7.08936 5.82703 7.08936 5.57766 7.33873C5.32828 7.58811 5.32828 7.99311 5.57766 8.24436L7.0502 9.7168Z",
    fill: "#F86557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtect);
export default __webpack_public_path__ + "static/media/protect.3e2f9737c93fe9965b112ae23c67a8bc.svg";
export { ForwardRef as ReactComponent };